import type { NotificationCategory } from "@workspace/dto/notification/definitions";
import type { NotificationType } from "@workspace/dto/notification/schema";
import { applicationAcceptedHandler } from "./application-accepted";
import { applicationDailyDigestHandler } from "./application-daily-digest";
import { applicationDraftReminderHandler } from "./application-draft-reminder";
import { applicationInterviewingHandler } from "./application-interviewing";
import { applicationNewHandler } from "./application-new";
import { applicationRejectedHandler } from "./application-rejected";
import { applicationShortlistedHandler } from "./application-shortlisted";
import { applicationSubmittedHandler } from "./application-submitted";
import { conversationEndedHandler } from "./conversation-ended";
import { interviewInviteHandler } from "./interview-invite";
import { interviewReminderHandler } from "./interview-reminder";
import { interviewStatusChangedHandler } from "./interview-status-changed";
import { messageNewHandler } from "./message-new";
import { nearbyJobRecommendationsHandler } from "./nearby-job-recommendations";
import type { NotificationIcon, NotificationTypeHandler } from "./types";
import { userOnboardingCompletionReminderHandler } from "./user-onboarding-completion-reminder";

const registry: Record<string, NotificationTypeHandler> = {
  "application.accepted": applicationAcceptedHandler,
  "application.daily_digest": applicationDailyDigestHandler,
  "application.draft_reminder": applicationDraftReminderHandler,
  "application.interviewing": applicationInterviewingHandler,
  "application.new": applicationNewHandler,
  "application.rejected": applicationRejectedHandler,
  "application.shortlisted": applicationShortlistedHandler,
  "application.submitted": applicationSubmittedHandler,
  "interview.invite": interviewInviteHandler,
  "interview.reminder": interviewReminderHandler,
  "interview.status_changed": interviewStatusChangedHandler,
  "message.new": messageNewHandler,
  "job.nearby_recommendations": nearbyJobRecommendationsHandler,
  "conversation.ended": conversationEndedHandler,
  "user.onboarding_completion_reminder":
    userOnboardingCompletionReminderHandler,
};

export function getHandler(
  type: NotificationType
): NotificationTypeHandler | undefined {
  return registry[type];
}

export function renderTitle(
  type: NotificationType,
  metadata: Record<string, unknown>
): string {
  return registry[type]?.title(metadata) ?? "Notification";
}

export function renderDescription(
  type: NotificationType,
  metadata: Record<string, unknown>
): string {
  return registry[type]?.description(metadata) ?? "";
}

export function getIcon(type: NotificationType): NotificationIcon {
  return registry[type]?.icon ?? "application";
}

export const notificationCategoryLabels: Record<string, string> = {
  account: "Account",
  messages: "Messages",
  applications: "Applications",
  interviews: "Interviews",
} satisfies Record<NotificationCategory, string>;
